const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/air_purifier/smart_appliance_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.air_purifier.powerDevice.title',
    secondaryTx: 'categories.air_purifier.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.air_purifier.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/air_purifier/smart_appliance_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.air_purifier.confirmPairingMode.title',
    secondaryTx: 'categories.air_purifier.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.air_purifier.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.air_purifier.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/appliance/reset_appliance_step_1.png'),
          primaryTx: 'categories.appliance.resetDevice.step1.title',
          secondaryTx: 'categories.appliance.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/appliance/reset_appliance_step_2.png'),
          primaryTx: 'categories.appliance.resetDevice.step2.title',
          secondaryTx: 'categories.appliance.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/appliance/reset_appliance_step_3.gif'),
          primaryTx: 'categories.appliance.resetDevice.step3.title',
          secondaryTx: 'categories.appliance.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
